import React from 'react';

import { TitleSmallText } from '@prisjakt/ui/text/variants';

type Props = {
  children: React.ReactNode;
};

export const ProductName = (props: Props) => {
  const { children } = props;

  return (
    <TitleSmallText containerProps={{ 'data-test': 'ProductName' }}>
      {children}
    </TitleSmallText>
  );
};
